<dx-popup
    #accDetail
    minWidth="150px"
    minHeight="150px"
    width="70%"
    height="95%"
    [title]="popupTitle"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onHidden)="onClosePopup()"
>
    <div *dxTemplate="let item of 'content'" class="cc-application-detail">
        <dx-box height="100%" width="100%" direction="col" class="application-detail-box" *ngIf="!!projectData">
            <dxi-item baseSize="auto">
                <dx-form [colCount]="2" width="100%" height="100%" [labelLocation]="defaultLabelLocation">
                    <dxi-item>
                        <div *dxTemplate>
                            <strong class="header-title">Project Details</strong>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <div *dxTemplate>
                            <dx-toolbar>
                                <dxi-item location="after">
                                    <div *dxTemplate class="attachment-btn-contain">
                                        <div class="cc-hyperlink" (click)="onProjectDocAttachmentClick()">
                                            <i
                                                title="Project Documents"
                                                class="fa-2x dx-theme-accent-as-text-color"
                                                [ngClass]="iconAttach"
                                            ></i>
                                        </div>

                                        <span class="project-attachment-count" *ngIf="projectAttachmentCount > 0">
                                            ({{ projectAttachmentCount }})
                                        </span>
                                    </div>
                                </dxi-item>
                                <dxi-item location="after">
                                    <div *dxTemplate class="acc-editor-icon">
                                        <app-notes-icon
                                            cssClass="fa-2x"
                                            title="Internal Project Notes"
                                            [hasNotes]="hasNotes"
                                            (onNotesClick)="onProjectNotesClick()"
                                        ></app-notes-icon>
                                    </div>
                                </dxi-item>
                                <dxi-item location="after" [visible]="!!isInteralUser">
                                    <div *dxTemplate class="acc-editor-icon">
                                        <div class="cc-hyperlink" (click)="onTransactionLogClick()">
                                            <i
                                                title="Internal Project Log"
                                                class="fa-2x dx-theme-accent-as-text-color"
                                                [ngClass]="iconLog"
                                            ></i>
                                        </div>
                                    </div>
                                </dxi-item>
                                <dxi-item location="after">
                                    <div *dxTemplate class="acc-editor-icon">
                                        <div class="cc-hyperlink" (click)="onBoardApprovalClick()">
                                            <i
                                                title="Board Approval"
                                                class="fa-2x cc-icon-check"
                                                [ngClass]="iconCheck"
                                            ></i>
                                        </div>
                                    </div>
                                </dxi-item>
                            </dx-toolbar>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Property"></dxo-label>
                        <div *dxTemplate>
                            {{ projectData?.property }}
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Community"></dxo-label>
                        <div *dxTemplate>
                            <span *ngIf="!!projectData.communityId">
                                <app-property-community-link
                                    [communityId]="projectData.communityId"
                                    [displayText]="projectData.community"
                                ></app-property-community-link>
                            </span>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Submitted by"></dxo-label>
                        <div *dxTemplate>
                            {{ projectData?.owner }}
                        </div>
                    </dxi-item>
                    <dxi-item itemType="empty"></dxi-item>
                    <dxi-item>
                        <dxo-label text="Project"></dxo-label>
                        <div *dxTemplate>
                            {{ projectData?.description }}
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Received from Owner"></dxo-label>
                        <div *dxTemplate>
                            {{ projectData?.receivedDate | date: dateFormat }}
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Assigned To"></dxo-label>
                        <div *dxTemplate>
                            {{ projectData?.assignedTo }}
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Last Modified By"></dxo-label>
                        <div *dxTemplate>
                            <app-user-bio-link
                                [user]="projectData.lastModifiedBy"
                                [communityId]="projectData.communityId"
                            ></app-user-bio-link>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Last Modified On"></dxo-label>
                        <div *dxTemplate>
                            {{ projectData?.lastModifiedDate | date: dateFormat }}
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Project Closed on"></dxo-label>
                        <div *dxTemplate>
                            {{ projectData?.projectClosedOn | date: dateFormat }}
                        </div>
                    </dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <div class="line-items">
                        <strong class="header-title">Line Items</strong>
                    </div>
                    <cc-data-grid-features #lineItemGridFeatures [dataSource]="projectData?.items">
                        <dx-data-grid
                            #lineItemGrid
                            appHasInternalUserColumns
                            class="cc-vertical-center-cell-data-grid"
                            width="100%"
                            height="100%"
                            [columnMinWidth]="100"
                            [dataSource]="projectData?.items"
                        >
                            <dxo-load-panel [enabled]="true"></dxo-load-panel>
                            <dxi-column dataField="accItemId" dataType="string" caption="Item #"></dxi-column>
                            <dxi-column
                                dataField="category"
                                dataType="string"
                                caption="Category"
                                [width]="185"
                            ></dxi-column>
                            <dxi-column
                                dataField="dueDate"
                                dataType="date"
                                caption="Due Date"
                                [format]="dateFormat"
                            ></dxi-column>
                            <dxi-column
                                dataField="daysRemaining"
                                dataType="number"
                                caption="Days Remaining"
                                cellTemplate="daysRemainingTemplate"
                            ></dxi-column>
                            <dxi-column
                                dataField="committeeSubmittedDate"
                                dataType="date"
                                caption="Commitee Submit Date"
                                [format]="dateFormat"
                            ></dxi-column>
                            <dxi-column
                                dataField="status"
                                dataType="string"
                                caption="Status"
                                [width]="150"
                            ></dxi-column>
                            <dxi-column dataField="description" dataType="string" caption="Description"></dxi-column>

                            <dxi-column
                                dataField="docCount"
                                dataType="number"
                                caption="Docs"
                                alignment="center"
                                cellTemplate="attachmentTemplate"
                            ></dxi-column>
                            <dxi-column
                                dataField="hasNotes"
                                dataType="string"
                                caption="Discussion Notes"
                                alignment="center"
                                cellTemplate="notesTemplate"
                            ></dxi-column>
                            <dxi-column caption="Logs" alignment="center" cellTemplate="logTemplate"></dxi-column>
                            <dxi-column
                                dataField="allowanceCategory"
                                dataType="string"
                                caption="Allowance Category"
                            ></dxi-column>
                            <dxi-column
                                dataField="allowanceSubCategory"
                                dataType="string"
                                caption="Allowance Sub-Category"
                            ></dxi-column>
                            <dxi-column
                                dataField="allowanceStartDate"
                                dataType="date"
                                caption="Allowance Start Date"
                                [format]="dateFormat"
                            ></dxi-column>
                            <dxi-column
                                dataField="allowanceEndDate"
                                dataType="date"
                                caption="Allowance End Date"
                                [format]="dateFormat"
                            ></dxi-column>
                            <dxi-column
                                dataField="finalized"
                                dataType="boolean"
                                caption="Finalize"
                                cellTemplate="booleanCellTemplate"
                            ></dxi-column>
                            <dxi-column
                                dataField="depositAmount"
                                caption="Deposit Amount"
                                [format]="currencyFormat"
                                [visible]="false"
                            ></dxi-column>
                            <dxi-column
                                dataField="depositRef"
                                dataType="string"
                                caption="Deposit Ref #"
                                [visible]="false"
                            ></dxi-column>
                            <dxi-column
                                dataField="depositStatusId"
                                dataType="string"
                                caption="Deposit Status"
                                [visible]="false"
                            ></dxi-column>
                            <dxi-column
                                dataField="depositTypeId"
                                dataType="string"
                                caption="Deposit Type"
                                [visible]="false"
                            ></dxi-column>
                            <dxi-column
                                dataField="responseToOwner"
                                dataType="string"
                                caption="Response to Owner"
                                [visible]="false"
                            ></dxi-column>

                            <div *dxTemplate="let data of 'daysRemainingTemplate'">
                                <div *ngIf="data.value < 0" class="cc-text-required">
                                    {{ data.value * -1 }} days overdue
                                </div>
                                <div *ngIf="data.value >= 0">{{ data.value }} days remaining</div>
                            </div>

                            <div *dxTemplate="let row of 'attachmentTemplate'">
                                <app-hyperlink-creator
                                    mode="hyperlinkOnly"
                                    textLocation="right"
                                    [displayText]="row.value > 0 ? '(' + row.value + ')' : ''"
                                    (onLinkClick)="onLineItemAttachmentClick(row.data)"
                                >
                                    <i
                                        class="dx-theme-accent-as-text-color cc-1-5x margin-right-3px"
                                        [ngClass]="iconAttach"
                                    ></i>
                                </app-hyperlink-creator>
                            </div>

                            <div *dxTemplate="let row of 'notesTemplate'">
                                <app-notes-icon
                                    cssClass="cc-1-5x"
                                    title="Notes"
                                    [hasNotes]="row.value"
                                    (onNotesClick)="onItemNotesClick(row.data)"
                                ></app-notes-icon>
                            </div>

                            <div *dxTemplate="let data of 'logTemplate'">
                                <div class="link-content cc-hyperlink">
                                    <i
                                        class="cc-1-5x dx-theme-accent-as-text-color"
                                        [ngClass]="iconLog"
                                        (click)="onTransactionLogClick(data.data, lineItemLog)"
                                    ></i>
                                </div>
                            </div>

                            <div *dxTemplate="let row of 'booleanCellTemplate'">
                                <i *ngIf="row.value" class="cc-check-icon cc-1-5x" [ngClass]="iconCheck"></i>
                                <i *ngIf="!row.value" class="cc-text-required cc-1-5x" [ngClass]="iconClose"></i>
                            </div>
                        </dx-data-grid>
                    </cc-data-grid-features>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <dx-toolbar width="100%" class="application-toolbar">
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Close"
                                [icon]="iconClose"
                                (onClick)="onClosePopup()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#accDetail' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<app-architectural-application-transaction-log
    *ngIf="showTransactionLog"
    [visible]="showTransactionLog"
    [title]="transactionLogTitle"
    [transactionLogResultData]="transactionLogResultData"
    (onTransactionLogClose)="showTransactionLog = false"
></app-architectural-application-transaction-log>

<app-board-approval-rules
    *ngIf="showBoardApprovalPopup"
    [visible]="showBoardApprovalPopup"
    [boardApprovalProcess]="projectData.boardApprovalRules"
    (closeBoardApprovalPopup)="showBoardApprovalPopup = false"
></app-board-approval-rules>

<app-architectual-application-notes-editor
    *ngIf="showNotesEditor"
    [visible]="showNotesEditor"
    [notesEditorParam]="notesEditorParam"
    [notesType]="notesType"
    (onNotesEditorClose)="showNotesEditor = false"
></app-architectual-application-notes-editor>

<app-architectural-application-attachment-editor
    #attachmentEditor
    *ngIf="showAttachments"
    [visible]="showAttachments"
    [customerId]="customerId"
    [docParam]="docParam"
    [isViewOnly]="isClosedApplication"
    (onClose)="onAttachmentClose()"
></app-architectural-application-attachment-editor>
